import styled from 'styled-components'

export const GlobalSearchLoadingHeadingStyled = styled.div`
  display: flex;
  align-items: center;
  gap: ${(props) => props.theme.space.small};
  padding: ${(props) => props.theme.space.small}
    ${(props) => props.theme.space.medium};
`
